"use strict";

import angular from "angular";

import { Events } from "../../../presentation/services/Events/Events";

class CompanyContactCreateDialog {
    constructor(locals, DesnuDialogService, $mdDialog) {
        this.Events = new Events();
        this.locals = locals;
        this.DesnuDialogService = DesnuDialogService;
        this.$mdDialog = $mdDialog;
        this.focusContact = this.locals.contacts.length;
    }

    onSaveContacts({ contacts }) {
        this.Events.send("relatorio.email.dialog.adccontato.salvar");
        this.$mdDialog.hide({ contacts });
    }

    onCancelContacts() {
        this.$mdDialog.cancel();
    }
}
angular.module("nucont.shared").controller("CompanyContactCreateDialog", [
        "locals",
        "DesnuDialogService",
        "$mdDialog",
        CompanyContactCreateDialog
    ]);
